import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserPermission } from 'src/services/users/userPermissions';

interface StateType {
  permissions: UserPermission[];
}

const initialState: StateType = {
  permissions: [],
};

export const PermissionsSlice = createSlice({
  name: 'Permissions',
  initialState,
  reducers: {
    setUserPermissions: (state, action: PayloadAction<UserPermission[]>) => {
      state.permissions = action.payload;
    },
  },
});

export const { setUserPermissions } = PermissionsSlice.actions;

export default PermissionsSlice.reducer;
